import { StoreChatMessages } from '@shared/models/interfaces/messages'

export const isNewMessageWithoutScroll = (
  nextMessages: StoreChatMessages,
  prevMessages: StoreChatMessages
) => {
  const prevLength = prevMessages?.data?.data?.length || 0
  const nextLength = nextMessages?.data?.data?.length || 0

  const prevPage = prevMessages?.data?.meta?.page || 0
  const nextPage = nextMessages?.data?.meta?.page || 0

  return nextLength > prevLength && nextPage <= prevPage
}
